import { render, staticRenderFns } from "./returnBtn.vue?vue&type=template&id=6276eb84&"
import script from "./returnBtn.vue?vue&type=script&lang=js&"
export * from "./returnBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports